import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    readonly width?: string;
    readonly height?: string;
}

export const LampIcon: React.FC<IconProps> = ({ ...props }) => (
    <svg
        width='158'
        height='158'
        viewBox='0 0 158 158'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {... props}
    >
        <mask
            id='mask0_1271_30180'
            type='alpha'
            maskUnits='userSpaceOnUse'
            x='-1'
            y='0'
            width='159'
            height='158'
        >
            <rect x='-0.000244141' width='158' height='158' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_1271_30180)'>
            <path
                d='M78.7459 139.411C76.0988 139.411 73.8253 138.688 71.9255 137.241C70.0257 135.792 68.9216 133.87 68.6135 131.474H65.1795C63.305 131.474 61.639 130.716 60.1814 129.201C58.7227 127.684 57.9934 125.952 57.9934 124.003V102.305C51.0274 97.9244 45.6203 92.2381 41.7721 85.2455C37.9239 78.2529 35.9998 70.6502 35.9998 62.4375C35.9998 50.0477 40.1445 39.544 48.4341 30.9264C56.7237 22.3088 66.8276 18 78.7459 18C90.6641 18 100.768 22.3088 109.058 30.9264C117.347 39.544 121.492 50.0477 121.492 62.4375C121.492 70.6502 119.572 78.254 115.731 85.2488C111.89 92.2446 106.479 97.9299 99.4983 102.305V124.003C99.4983 125.952 98.769 127.684 97.3103 129.201C95.8528 130.716 94.1867 131.474 92.3122 131.474H88.8783C88.5701 133.87 87.4661 135.792 85.5662 137.241C83.6664 138.688 81.393 139.411 78.7459 139.411ZM65.1795 124.003H92.3122V116.888H65.1795V124.003ZM65.1795 111.065H92.3122V104.419H65.1795V111.065ZM63.7546 96.949H75.7742V74.2743L61.7567 59.7021L65.8128 55.4872L78.7459 68.9961L91.6789 55.4872L95.7351 59.7021L81.7175 74.2743V96.949H93.7371C99.9073 93.9613 104.878 89.3573 108.649 83.1371C112.42 76.917 114.306 70.0171 114.306 62.4375C114.306 52.0896 110.868 43.3414 103.991 36.193C97.1151 29.0446 88.6999 25.4704 78.7459 25.4704C68.7918 25.4704 60.3766 29.0446 53.5003 36.193C46.624 43.3414 43.1859 52.0896 43.1859 62.4375C43.1859 70.0171 45.0714 76.917 48.8426 83.1371C52.6137 89.3573 57.5844 93.9613 63.7546 96.949Z'
                fill='#D0BFE8'
            />
        </g>
    </svg>
);
